import axios from 'axios'
import Swal from 'sweetalert2'
import { isDesktop } from 'react-device-detect'

import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY, REQUEST_HEADER_LANG } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

const BaseService = axios.create({
    // timeout: 60000,
    baseURL: (process.env.REACT_APP_DEVELOPMENT === "true" ? process.env.REACT_APP_API_DEVELOPMENT_URL + 'api/member/' : appConfig.apiPrefix)  //development
    // baseURL: appConfig.apiPrefix, 
})

BaseService.defaults.headers.common['X-Authorization'] = process.env.REACT_APP_X_AUTHORIZATION_KEY;

if (localStorage.getItem('accessToken')) {
    BaseService.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken');
}

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)

        const accessToken = persistData.auth.session.token
        const lang = persistData.locale.currentLang

        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }
        config.headers[REQUEST_HEADER_LANG] = lang

        return config
    },
    (error) => {
        return Promise.reject(error.message)
    }
)

BaseService.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response, config } = error;
        const currentLang = config?.headers?.[REQUEST_HEADER_LANG] || 'en';

        const translationTitle = {
            en: 'Error',
            zh_cn: '错误',
            ms: 'Kesilapan',
            th: 'ข้อผิดพลาด',
            id: 'Kesalahan',
            vi: 'lỗi',
            us: 'Error',
        }

        const translationText = {
            en: 'Network Error',
            zh_cn: '网络错误',
            ms: 'Rangkaian Kesilapan',
            th: 'ข้อผิดพลาดของเครือข่าย',
            id: 'Kesalahan Jaringan',
            vi: 'lỗi mạng',
            us: 'Network Error',
        }

        const translationButton = {
            en: 'OK',
            zh_cn: '好的',
            ms: 'Okey',
            th: 'ตกลง',
            id: 'Oke',
            vi: 'VÂNG',
            us: 'OK',
        }
        
        if (error.message === 'Network Error') {
            Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">',
                title: translationTitle[currentLang],
                text: translationText[currentLang],
                icon: 'error',
                confirmButtonText: translationButton[currentLang],
                customClass: (!isDesktop) ? {
                    container: "swal-mobile-container failed",
                    icon: "swal-failed-icon",
                } : {
                    icon: "swal-failed-icon",
                },
                animation: false,
            });

            return new Promise(() => {}); // stop propagation
        }
            
        // Handle token issues
        const tokenErrors = ["Token is Incompatible", "Token is Expired", "Token is Invalid"];
        if (
            response?.data?.message &&
            Array.isArray(response.data.message) &&
            tokenErrors.includes(response.data.message[0])
        ) {
            localStorage.clear();
            window.location.href = "/";
            return new Promise(() => {}); // stop propagation
        }

        // Handle unauthorized error
        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess());
            return new Promise(() => {}); // stop propagation
        }

        return Promise.reject(error.message);
    }
)

export default BaseService
